import {
  NOTIFICATION_TYPE,
  type NotificationSettings
} from "../types/notification.types.ts"

// A type written through another row's switch (the server's
// NOTIFICATION_SETTING_MIRRORS) carries that row's choice.
const WRITTEN_THROUGH: Record<number, number> = {
  [NOTIFICATION_TYPE.MESSAGE_CUSTOMER]: NOTIFICATION_TYPE.MESSAGE_DIRECT
}

// Whether the in-tab desktop alert may show for this type. Settings not yet
// loaded, or a type the screen does not list, fall back to showing it: the
// server has already chosen this recipient, and only a saved Off silences it.
export function desktopWantedFor(
  settings: NotificationSettings | null,
  notificationName: number | string | null | undefined
): boolean {
  if (!settings || notificationName == null) return true
  const name = Number(notificationName)
  const rowType = WRITTEN_THROUGH[name] ?? name
  const row = Object.values(settings)
    .flat()
    .find((item) => Number(item.notification_type) === rowType)
  return row ? row.desktop !== false : true
}

export function anyDesktopOn(settings: NotificationSettings | null): boolean {
  if (!settings) return false
  return Object.values(settings)
    .flat()
    .some((item) => item.desktop === true)
}
